import React from 'react';
import PropTypes from 'prop-types';
import Translate from 'components/Translate';
import NavigationUtil from 'utils/NavigationUtil';
import { hideModal } from '../../../actions/';

const BadgeImage = (props) => {
    const { badge, connection } = props;

    if (!connection) {
        return <div className="badge-status-msg">{getMessage(badge.earnedByMe)}</div>;
    }

    return (
        <a
            href={NavigationUtil.url('/badges/' + connection)}
            className="badge-status-msg"
            onClick={(e) => onEarnedStatusClicked(e, props)}
        >
            {getMessage(badge.earnedByMe)}
        </a>
    );
};

const onEarnedStatusClicked = (e, props) => {
    const { dispatch } = props;

    dispatch(hideModal());
    NavigationUtil.anchorTagHandler(e);
};

const getMessage = (earnedByMe) => {
    return earnedByMe ? (
        <Translate ns="common" content="badge_earned_status" />
    ) : (
        <Translate ns="common" content="badge_not_earned_status" />
    );
};

BadgeImage.propTypes = {
    badge: PropTypes.object.isRequired,
    connection: PropTypes.string
};

export default BadgeImage;
